module.exports = __webpack_public_path__ + "72658548665824ff29a5c1aef3890345.MP3";